import React from 'react'
import { Box, Loading, Text } from '@workwhile/ui'
import { I9DocumentUpload } from 'components/Users/I9DocumentUpload/I9DocumentUpload'
import { useInvalidateWorkAuthorizationExpirationReport } from 'queries/admin/i9/useWorkAuthorizationExpirationReport'
import {
  useInvalidateUnprocessedI9Forms,
  useUserProfileById,
} from 'queries/user'
import { Link } from 'react-router-dom'

export function I9ReverificationDetailView({ userId }: { userId: number }) {
  const { data: user, isLoading } = useUserProfileById(userId)
  const invalidateUnprocessedI9Forms = useInvalidateUnprocessedI9Forms()
  const invalidateWorkAuthorizationExpirationReport =
    useInvalidateWorkAuthorizationExpirationReport()

  if (isLoading) {
    return <Loading />
  }

  if (!user) {
    return <Text>No user found</Text>
  }

  return (
    <Box>
      <Text fontWeight="bold" mb={2}>
        <Link to={`/users/${userId}`}>{user.name}</Link>
        <Text as="span" color="lightText" ml={2}>
          User ID {userId}
        </Text>
      </Text>
      <I9DocumentUpload
        user={user}
        layout="inline"
        onUploadSuccess={() => {
          invalidateUnprocessedI9Forms()
          invalidateWorkAuthorizationExpirationReport()
        }}
      />
    </Box>
  )
}
